export enum FormListSortColumn {
  FormName = 1,
  SubmissionDate = 2,
  StatusChangeDate = 3,
}